import React from 'react';

import AgDateFilterLayout from '@/components/AgGrid/components/AgDateFilter/AgDateFilterLayout';
import useAgDateFilterCore from '@/components/AgGrid/components/AgDateFilter/hooks/useAgDateFilterCore';
import { AgDateFilterProps } from '@/components/AgGrid/components/AgDateFilter/types';

const AgDateFilterFE: React.FC<AgDateFilterProps> = ({
  defaultOption,
  model,
  onModelChange,
  format,
  buttons,
  colDef,
  filterValueTransform,
}) => {
  const core = useAgDateFilterCore({
    defaultOption,
    model,
    onModelChange,
    field: colDef.field,
    isBEGrid: false,
    filterValueTransform,
  });

  return <AgDateFilterLayout format={format} buttons={buttons} {...core} />;
};

export default AgDateFilterFE;
